import React, { useEffect } from 'react';
import { text } from '../../../../utils/text';
import { Action, RoutePath } from '../../../../utils/types';
import { InputNumber } from '../../../common/Form/InputNumber';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Card } from '../../../common/Card/Card';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import * as yup from 'yup';
import { Form } from '../../../common/Form/Form';
import { Layout } from '../../../common/Layout/Layout';
import { useFormContext } from '../../../../context/FormContext';
export const AmountForm = () => {
    const [{ amountData }, dispatch] = useFormContext();
    const history = useHistory();
    const { handleSubmit, control } = useForm({
        resolver: yupResolver(amountValidationSchema),
        defaultValues: amountData,
        mode: 'onBlur',
    });
    useEffect(() => {
        trackScenario(scenarioSteps.AMOUNT);
    }, []);
    const submit = (data) => {
        dispatch({
            type: Action.UPDATE_AMOUNT_DATA,
            amountData: data,
        });
        history.push(RoutePath.RAADGIVNING_EGNETHET);
    };
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 2, title: text.FORM.AMOUNT_FORM.TITLE.no, subtitle: text.FORM.AMOUNT_FORM.DESCRIPTION.no },
            React.createElement(Form, { onSubmit: handleSubmit(submit) },
                React.createElement(InputNumber, { name: "lumpSum", id: "lumpSum", labelText: text.FORM.AMOUNT_FORM.LUMP_SUM.LABEL_TEXT.no, postfixText: "kr", control: control, placeholder: '0' }),
                React.createElement(InputNumber, { name: "annuity", id: "annuity", labelText: text.FORM.AMOUNT_FORM.ANNUITY.LABEL_TEXT.no, postfixText: "kr/mnd", control: control, placeholder: '0' }),
                React.createElement(NavigationButtons, { isSubmit: true, onPrevious: () => history.push(RoutePath.KONTO), nextText: text.NAV_BUTTONS.NEXT.no })))));
};
const MIN_AMOUNT = 300;
const amountValidationSchema = yup.object().shape({
    lumpSum: yup
        .number()
        .integer()
        .transform((value) => {
        return isNaN(value) ? 0 : value;
    })
        .test('isAtLeastMinAmount', text.FORM.AMOUNT_FORM.VALIDATION.MIN(MIN_AMOUNT).no, (value) => {
        if (value && value != 0) {
            return value >= MIN_AMOUNT;
        }
        return true;
    }),
    annuity: yup
        .number()
        .integer()
        .transform((value) => {
        return isNaN(value) ? 0 : value;
    })
        .test('isAtLeastMinAmount', text.FORM.AMOUNT_FORM.VALIDATION.MIN(MIN_AMOUNT).no, (value) => {
        if (value && value != 0) {
            return value >= MIN_AMOUNT;
        }
        return true;
    })
        .when('lumpSum', {
        is: 0,
        then: yup.number().min(MIN_AMOUNT, text.FORM.AMOUNT_FORM.VALIDATION.REQUIRED(MIN_AMOUNT).no),
    }),
});
